import { principles, testimonials } from "@/mocks/site";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HomeVoice() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="Our Principles"
        title="内容原则 · 理性吃瓜"
        desc="我们只做整理与复盘，不做人身攻击，也不替任何一方下定论。"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {principles.map((item) => (
          <div key={item.title} className="rounded-lg bg-background-50 border border-background-200 p-6">
            <span className="w-11 h-11 rounded-full bg-primary-50 flex items-center justify-center text-2xl text-primary-600">
              <i className={item.icon} />
            </span>
            <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-14">
        <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6">
          读者怎么说
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="rounded-lg bg-background-50 border border-background-200 p-6 flex flex-col"
            >
              <span className="text-accent-500 text-lg">
                <i className="ri-double-quotes-l" />
              </span>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                {item.content}
              </blockquote>
              <figcaption className="mt-4 pt-4 border-t border-background-200">
                <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                <span className="block text-xs text-foreground-500 mt-0.5">{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}